import { Col, Divider, Row, Typography } from 'antd';
import { TitleProps } from 'antd/lib/typography/Title';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';
import InfoTooltip from 'components/molecules/InfoTooltip';

const TitleAnt = Typography.Title;

interface ITitle extends TitleProps {
    text: string;
    level: 1 | 2 | 3 | 4 | 5;
    dividerTitle?: boolean;
    dividerTooltip?: string;
}

const Title: React.FC<ITitle> = props => {
    return props.dividerTitle ? (
        props.children ? (
            <Row
                style={{
                    minWidth: '300px'
                }}
            >
                <Col flex="auto">
                    <Divider orientation="left">
                        <TranslateText>{props.text}</TranslateText>
                        {props.dividerTooltip && <InfoTooltip title={props.dividerTooltip} />}
                    </Divider>
                </Col>
                <Col
                    style={{
                        marginLeft: '20px',
                        position: 'relative',
                        top: 12
                    }}
                >
                    {props.children}
                </Col>
                <Col
                    style={{
                        width: '45px',
                        marginLeft: '10px',
                        paddingTop: '5px'
                    }}
                >
                    <Divider className="TitleDivider" />
                </Col>
            </Row>
        ) : (
            <Divider orientation="left">
                <TitleAnt
                    {...props}
                    level={props.level}
                    style={{
                        position: 'relative',
                        top: -12
                    }}
                >
                    <TranslateText>{props.text}</TranslateText>
                    {props.dividerTooltip && <InfoTooltip title={props.dividerTooltip} />}
                </TitleAnt>
            </Divider>
        )
    ) : (
        <TitleAnt
            {...props}
            level={props.level}
            style={{
                marginTop: 4,
                ...props.style
            }}
        >
            <TranslateText>{props.text}</TranslateText>
        </TitleAnt>
    );
};

export default Title;
